module.exports = __webpack_public_path__ + "img/HershOmer.d257ffd7.jpg";